import { createBaseApi } from '@/api/baseApi'

const TEMPLATE_STAGE_LINE_URL = 'consignment/status-line-templates'

export default {
  ...createBaseApi(TEMPLATE_STAGE_LINE_URL)
}
